import { DataSample } from "../domain/types";
import { apiGet } from "./api";

function formatDateToIso(date: Date) {
	if (typeof (date) !== typeof (Date)) {
		date = new Date(date);
	}
	return date.toISOString();
}

export async function getLatestValues(): Promise<DataSample[] | null> {
	return apiGet<DataSample[]>("values/latest/all");
}

export async function getHistoricalData(stationId: string, mvId: string, fromDate: Date, toDate: Date | null): Promise<DataSample[] | null> {
	try {
		return apiGet<DataSample[]>(`values/${stationId.toUpperCase()}/${mvId.toUpperCase()}/log?includeInvalid=false&from=${formatDateToIso(fromDate)}${toDate ? "&to=" + formatDateToIso(toDate) : ""}`);
	} catch (error) {
		return null;
	}
}